import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import { showToast } from '../../components/toast/actions';

export function* getUserSettings() {
    const response = yield call(api.getUserPortalSettings);
    if (response.status === 200) {
        yield put(actions.getSettingPreferencesSuccess(response.data));
    } else {
        yield put(actions.getSettingPreferencesFailure());
    }
}

export function* getUserSettingsSaga() {
    yield takeLatest(actions.GET_USER_SETTINGS_REQUEST, getUserSettings);
}

export function* saveSettingPreferences(request) {
    const response = yield call(api.saveSettingPreferences, request);
    if (response.status === 200) {
        yield put(actions.saveSettingPreferencesSuccess());
        yield put(showToast('settingsHaveBeenSaved', 'success'));
    } else {
        yield put(actions.saveSettingPreferencesFailure());
        yield put(showToast(response.message, 'error'));
    }
}

export function* saveSettingPreferencesSaga() {
    yield takeLatest(actions.SAVE_SETTING_PREFERENCE_REQUEST, saveSettingPreferences);
}



// WEBPACK FOOTER //
// ./app/containers/privacy-settings/saga.js